/* MaxPrint v77 - Eid Al Etihad 55. Tiny, dependency-free, loaded with defer only while
   snippets/mx-eid55-on says the campaign is on. Re-checks the end in the browser (pages can
   be cached) and removes every .mx55-x element after 2026-12-05T00:00:00+04:00.
   Pieces: live countdowns, mobile strip rotation, waving flag (livelier with scroll speed),
   flag tap / typing "55" -> ~3 s canvas fireworks in flag colours, add-to-cart celebration
   on /cart (sessionStorage flag set on submit, never touching the submit itself).
   prefers-reduced-motion: no canvas motion (one static frame), no flutter, no rotation.
   QA hooks: ?eid55_now=<ISO>, ?eid55=off|on, window.MX55.{setNow,state,fire,celebrate}. */
(function () {
  'use strict';
  var D = document, H = D.documentElement, W = window;
  if (W.MX55) return;
  var END = 1796414400000, TODAY = 1796155200000, TARGET = 1796155200000;
  var COLORS = ['#EF3340', '#009A44', '#ffffff', '#EF3340', '#009A44', '#ffffff', '#ffd35a'];
  var offset = 0;
  try {
    var mq = /[?&]eid55_now=([^&]+)/.exec(location.search);
    if (mq) { var tq = Date.parse(decodeURIComponent(mq[1])); if (!isNaN(tq)) offset = tq - Date.now(); }
  } catch (e) {}
  function now() { return Date.now() + offset; }
  var RM = W.matchMedia ? W.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function reduced() { return !!RM.matches; }
  function $$(s, r) { return Array.prototype.slice.call((r || D).querySelectorAll(s)); }
  function ls(k, v) { try { if (v === undefined) return W.localStorage.getItem(k); W.localStorage.setItem(k, v); } catch (e) { return null; } }
  function ss(k, v) { try { if (v === undefined) return W.sessionStorage.getItem(k); if (v === null) W.sessionStorage.removeItem(k); else W.sessionStorage.setItem(k, v); } catch (e) { return null; } }

  var timers = [], killed = false;
  function killAll() {
    killed = true;
    timers.forEach(function (t) { clearTimeout(t); clearInterval(t); });
    $$('.mx55-x').forEach(function (el) { if (el.parentNode) el.parentNode.removeChild(el); });
    H.classList.remove('mx55-on'); H.classList.add('mx55-off');
    stopFx(true);
  }
  function state() { var n = now(); return n >= END ? 'off' : (n >= TODAY ? 'today' : 'on'); }

  /* ------------------------------------------------------------ countdown */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function paint() {
    var st = state();
    if (st === 'off') { killAll(); return; }
    var diff = Math.max(0, Math.floor((TARGET - now()) / 1000));
    var v = { d: pad(Math.floor(diff / 86400)), h: pad(Math.floor(diff % 86400 / 3600)), m: pad(Math.floor(diff % 3600 / 60)), s: pad(diff % 60) };
    $$('[data-mx55-cd]').forEach(function (cd) {
      var c = cd.querySelector('.mx55-cd__count'), t = cd.querySelector('.mx55-cd__today');
      if (c) c.hidden = st === 'today';
      if (t) t.hidden = st !== 'today';
      if (st === 'today') return;
      ['d', 'h', 'm', 's'].forEach(function (k) {
        var el = cd.querySelector('[data-mx55-' + k + ']');
        if (el && el.textContent !== v[k]) el.textContent = v[k];
      });
    });
  }
  function tick() {
    if (killed) return;
    paint();
    if (!killed) timers.push(setTimeout(tick, 1000 - (now() % 1000) + 15));
  }

  /* ------------------------------------------------------------ mobile strip rotation */
  function rotateStrip() {
    var strip = D.querySelector('[data-mx55-strip]');
    if (!strip) return;
    timers.push(setInterval(function () {
      if (D.hidden) return;
      strip.classList.toggle('is-b');
    }, 4800));
  }

  /* ------------------------------------------------------------ fireworks / confetti engine */
  var cv = null, ctx = null, parts = [], raf = 0, spawnEnd = 0, hardEnd = 0, schedule = [], dpr = 1, last = 0;
  function sizeCv() {
    if (!cv) return;
    dpr = Math.min(2, W.devicePixelRatio || 1);
    cv.width = Math.round(W.innerWidth * dpr); cv.height = Math.round(W.innerHeight * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  function ensureCv(dim) {
    if (cv) return;
    cv = D.createElement('canvas');
    cv.className = 'mx55-fx mx55-x';
    cv.setAttribute('aria-hidden', 'true');
    if (!dim) cv.style.background = 'none';
    D.body.appendChild(cv);
    ctx = cv.getContext('2d');
    sizeCv();
    W.addEventListener('resize', sizeCv);
    if (reduced()) cv.classList.add('is-on');
    else requestAnimationFrame(function () { if (cv) cv.classList.add('is-on'); });
  }
  function stopFx(now_) {
    if (raf) cancelAnimationFrame(raf);
    raf = 0; parts = []; schedule = [];
    if (!cv) return;
    var c = cv; cv = null; ctx = null;
    W.removeEventListener('resize', sizeCv);
    if (now_ || reduced()) { if (c.parentNode) c.parentNode.removeChild(c); return; }
    c.classList.remove('is-on');
    setTimeout(function () { if (c.parentNode) c.parentNode.removeChild(c); }, 400);
  }
  function pick() { return COLORS[(Math.random() * COLORS.length) | 0]; }
  function spark(x, y, vx, vy, col, life) {
    parts.push({ t: 's', x: x, y: y, px: x, py: y, vx: vx, vy: vy, c: col, l: life, L: life, r: 1.4 + Math.random() * 1.4 });
  }
  function burst(x, y, n) {
    n = n || 70;
    var base = pick();
    for (var i = 0; i < n; i++) {
      var a = Math.PI * 2 * i / n + Math.random() * 0.2, sp = 2.6 + Math.random() * 4.2;
      spark(x, y, Math.cos(a) * sp, Math.sin(a) * sp, Math.random() < 0.55 ? base : pick(), 55 + Math.random() * 35);
    }
  }
  function rocket(x, ty) {
    parts.push({ t: 'r', x: x, y: W.innerHeight + 10, px: x, py: W.innerHeight + 10, vx: (Math.random() - 0.5) * 1.2, vy: -(9 + Math.random() * 3), ty: ty, c: '#ffd35a', l: 120, L: 120, r: 2 });
  }
  function confetti(n, y0, spread) {
    var w = W.innerWidth;
    for (var i = 0; i < n; i++) {
      parts.push({ t: 'c', x: Math.random() * w, y: (y0 || 0) - Math.random() * (spread || 60), vx: (Math.random() - 0.5) * 2.4, vy: 1.5 + Math.random() * 2.8,
        c: pick(), l: 160 + Math.random() * 60, L: 220, w: 6 + Math.random() * 5, h: 10 + Math.random() * 6, a: Math.random() * 6.28, va: (Math.random() - 0.5) * 0.3, ph: Math.random() * 6.28 });
    }
  }
  /* the fireworks spell 55, like the banner art */
  function word55() {
    var w = Math.min(W.innerWidth * 0.62, 520), hh = w * 0.62;
    var oc = D.createElement('canvas'), ow = 220, oh = 136;
    oc.width = ow; oc.height = oh;
    var o = oc.getContext('2d');
    o.fillStyle = '#000';
    o.font = '400 128px "Archivo Black", "Arial Black", Impact, sans-serif';
    o.textAlign = 'center'; o.textBaseline = 'middle';
    o.fillText('55', ow / 2, oh / 2 + 6);
    var data = o.getImageData(0, 0, ow, oh).data, pts = [], step = 4;
    for (var y = 0; y < oh; y += step) for (var x = 0; x < ow; x += step) if (data[(y * ow + x) * 4 + 3] > 128) pts.push([x / ow, y / oh]);
    var cx = W.innerWidth / 2, cy = Math.max(hh / 2 + 30, W.innerHeight * 0.34);
    pts.forEach(function (p) {
      var tx = cx + (p[0] - 0.5) * w, ty = cy + (p[1] - 0.5) * hh;
      var col = p[1] < 0.42 ? '#009A44' : (p[1] < 0.62 ? '#ffffff' : '#EF3340');
      parts.push({ t: 'w', x: cx, y: cy + hh * 0.2, px: cx, py: cy, tx: tx, ty: ty, c: col, l: 120, L: 120, r: 1.8 + Math.random() * 0.9, k: 0 });
    });
  }
  function step(ts) {
    if (!cv) return;
    var dt = last ? Math.min(2.5, (ts - last) / 16.67) : 1; last = ts;
    var n = now();
    while (schedule.length && schedule[0].at <= n) schedule.shift().fn();
    ctx.clearRect(0, 0, W.innerWidth, W.innerHeight);
    ctx.globalCompositeOperation = 'lighter';
    for (var i = parts.length - 1; i >= 0; i--) {
      var p = parts[i];
      p.l -= dt;
      if (p.t === 'r') {
        p.px = p.x; p.py = p.y; p.x += p.vx * dt; p.y += p.vy * dt; p.vy += 0.12 * dt;
        if (p.y <= p.ty || p.vy >= -1) { burst(p.x, p.y, 64); parts.splice(i, 1); continue; }
        ctx.strokeStyle = 'rgba(255,211,90,.9)'; ctx.lineWidth = 2;
        ctx.beginPath(); ctx.moveTo(p.px, p.py + 10); ctx.lineTo(p.x, p.y); ctx.stroke();
      } else if (p.t === 's') {
        p.px = p.x; p.py = p.y;
        p.vx *= Math.pow(0.985, dt); p.vy = p.vy * Math.pow(0.985, dt) + 0.05 * dt;
        p.x += p.vx * dt; p.y += p.vy * dt;
        var al = Math.max(0, p.l / p.L);
        ctx.globalAlpha = al; ctx.strokeStyle = p.c; ctx.lineWidth = p.r;
        ctx.beginPath(); ctx.moveTo(p.px, p.py); ctx.lineTo(p.x, p.y); ctx.stroke();
        if (Math.random() < 0.08) { ctx.fillStyle = '#fff'; ctx.fillRect(p.x, p.y, 1.5, 1.5); }
      } else if (p.t === 'w') {
        var age = p.L - p.l;
        if (age < 34) { p.k = 1 - Math.pow(1 - age / 34, 3); p.x = p.px + (p.tx - p.px) * p.k; p.y = (p.py + (p.ty - p.py) * p.k); }
        else if (age > 78) { p.vy = (p.vy || 0) + 0.06 * dt; p.y += p.vy * dt; }
        ctx.globalAlpha = Math.max(0, Math.min(1, p.l / 40)) * (0.75 + Math.random() * 0.25);
        ctx.fillStyle = p.c; ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283); ctx.fill();
        ctx.globalAlpha *= 0.22; ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 2.6, 0, 6.283); ctx.fill();
      } else {
        p.ph += 0.08 * dt; p.a += p.va * dt;
        p.x += (p.vx + Math.sin(p.ph) * 0.8) * dt; p.y += p.vy * dt;
        ctx.globalAlpha = Math.min(1, p.l / 30); ctx.globalCompositeOperation = 'source-over';
        ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.a); ctx.scale(1, Math.abs(Math.cos(p.ph)) * 0.8 + 0.2);
        ctx.fillStyle = p.c; ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore(); ctx.globalCompositeOperation = 'lighter';
        if (p.y > W.innerHeight + 30) p.l = 0;
      }
      if (p.l <= 0) parts.splice(i, 1);
    }
    ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over';
    if (n > hardEnd || (n > spawnEnd && !parts.length && !schedule.length)) { stopFx(); return; }
    raf = requestAnimationFrame(step);
  }
  function staticFrame(kind) {
    /* reduced motion: one still frame of confetti, gone after 1.4 s - no movement at all */
    ensureCv(false);
    var w = W.innerWidth, h = W.innerHeight;
    for (var i = 0; i < (kind === 'cart' ? 40 : 70); i++) {
      ctx.save(); ctx.translate(Math.random() * w, Math.random() * h * (kind === 'cart' ? 0.4 : 1)); ctx.rotate(Math.random() * 6.28);
      ctx.fillStyle = pick(); ctx.globalAlpha = 0.9; ctx.fillRect(-4, -7, 8, 14); ctx.restore();
    }
    timers.push(setTimeout(function () { stopFx(true); }, 1400));
  }
  function fire(origin) {
    if (killed) return;
    if (reduced()) { if (!cv) staticFrame('fw'); return; }
    var start = !cv;
    ensureCv(true);
    var n = now(), w = W.innerWidth, h = W.innerHeight;
    spawnEnd = Math.max(spawnEnd, n + 2600); hardEnd = n + 4200;
    var ox = origin ? origin.x : w / 2, oy = origin ? origin.y : h * 0.3;
    burst(ox, oy, 80);
    var plan = [[220, function () { word55(); }], [520, function () { rocket(w * (0.15 + Math.random() * 0.2), h * (0.18 + Math.random() * 0.15)); }],
      [900, function () { rocket(w * (0.65 + Math.random() * 0.2), h * (0.15 + Math.random() * 0.15)); }],
      [1300, function () { rocket(w * (0.3 + Math.random() * 0.4), h * (0.12 + Math.random() * 0.12)); }],
      [1750, function () { rocket(w * (0.1 + Math.random() * 0.8), h * (0.2 + Math.random() * 0.15)); }],
      [2150, function () { rocket(w * (0.1 + Math.random() * 0.8), h * (0.2 + Math.random() * 0.15)); }]];
    plan.forEach(function (p) { schedule.push({ at: n + p[0], fn: p[1] }); });
    schedule.sort(function (a, b) { return a.at - b.at; });
    confetti(Math.min(90, Math.round(w / 12)), -10, 120);
    schedule.push({ at: n + 1200, fn: function () { confetti(Math.min(50, Math.round(w / 20)), -10, 60); } });
    schedule.sort(function (a, b) { return a.at - b.at; });
    if (start) { last = 0; raf = requestAnimationFrame(step); }
  }
  function celebrate(fromY) {
    if (killed) return;
    if (reduced()) { if (!cv) staticFrame('cart'); return; }
    var start = !cv;
    ensureCv(false);
    var n = now();
    spawnEnd = Math.max(spawnEnd, n + 1600); hardEnd = Math.max(hardEnd, n + 3400);
    confetti(Math.min(140, Math.round(W.innerWidth / 7)), Math.max(0, fromY || 0), 40);
    if (start) { last = 0; raf = requestAnimationFrame(step); }
  }

  /* ------------------------------------------------------------ waving flag */
  function initFlag() {
    var btn = D.querySelector('[data-mx55-flag]');
    if (!btn) return;
    var hint = D.querySelector('[data-mx55-hint]');
    btn.addEventListener('click', function () {
      if (hint) hint.hidden = true;
      ls('mx55hint', '1');
      var r = btn.getBoundingClientRect();
      fire({ x: r.left + r.width / 2, y: r.top + r.height / 2 });
    });
    if (hint && !ls('mx55hint')) {
      /* v78: the hint sits ABOVE the flag (over our own strip), is kept inside the viewport and goes away on
         the first scroll / pointer / key / focus anywhere, or when a menu, drawer or the search is open */
      var hideHint = function () {
        hint.hidden = true;
        ['scroll', 'pointerdown', 'keydown', 'focusin', 'resize'].forEach(function (ev) { W.removeEventListener(ev, hideHint, true); });
      };
      var busy = function () {
        return !!D.querySelector('[aria-expanded="true"][aria-controls], .search-bar.is-expanded, .header__search-bar-wrapper.is-fixed, #mobile-menu[aria-hidden="false"], .popover[aria-hidden="false"], .mini-cart[aria-hidden="false"]') ||
          (D.activeElement && /^(INPUT|TEXTAREA|SELECT)$/.test(D.activeElement.tagName));
      };
      timers.push(setTimeout(function () {
        var r = btn.getBoundingClientRect();
        if (!r.width || r.top < 30 || W.scrollY > 40 || busy()) return;
        hint.style.setProperty('--mx55-hx', '0px');
        hint.hidden = false; ls('mx55hint', '1');
        var h = hint.getBoundingClientRect(), pad = 8, dx = 0;
        if (h.left < pad) dx = pad - h.left; else if (h.right > W.innerWidth - pad) dx = (W.innerWidth - pad) - h.right;
        if (dx) hint.style.setProperty('--mx55-hx', Math.round(dx) + 'px');
        ['scroll', 'pointerdown', 'keydown', 'focusin', 'resize'].forEach(function (ev) { W.addEventListener(ev, hideHint, { capture: true, passive: true }); });
        timers.push(setTimeout(hideHint, 4500));
      }, 1600));
    }
    if (reduced()) return;
    /* livelier with scroll speed: extra wave on the outer slice groups + faster CSS wave */
    var outer = $$('.mx55-fs', btn), inner = $$('.mx55-fw', btn);
    var amps = outer.map(function (g) { return parseFloat(g.getAttribute('data-a')) || 0; });
    var anims = [];
    var k = 0, target = 0, lastY = W.scrollY, lastT = performance.now(), loop = 0, ph = 0;
    function getAnims() { if (!anims.length && inner[0] && inner[0].getAnimations) inner.forEach(function (g) { anims = anims.concat(g.getAnimations()); }); return anims; }
    function frame(t) {
      k += (target - k) * 0.25; target *= 0.94; ph += 0.32 + k * 0.3;
      outer.forEach(function (g, i) { g.style.transform = k > 0.01 ? 'translateY(' + (Math.sin(ph - i * 0.55) * amps[i] * 2.6 * k).toFixed(2) + 'px)' : ''; });
      getAnims().forEach(function (a) { a.playbackRate = 1 + k * 1.6; });
      if (k > 0.01 || target > 0.01) loop = requestAnimationFrame(frame);
      else { loop = 0; outer.forEach(function (g) { g.style.transform = ''; }); getAnims().forEach(function (a) { a.playbackRate = 1; }); }
    }
    W.addEventListener('scroll', function () {
      var t = performance.now(), y = W.scrollY, v = Math.abs(y - lastY) / Math.max(16, t - lastT) * 1000;
      lastY = y; lastT = t;
      target = Math.min(1, Math.max(target, v / 1600));
      if (!loop && !killed) loop = requestAnimationFrame(frame);
    }, { passive: true });
  }

  /* ------------------------------------------------------------ easter egg: type 55 */
  function initKeys() {
    var prev = 0;
    D.addEventListener('keydown', function (e) {
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      var t = e.target, tag = t && t.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (t && t.isContentEditable)) { prev = 0; return; }
      if (e.key === '5' || e.key === '٥') {
        var n = Date.now();
        if (prev && n - prev < 1200) { prev = 0; fire(); } else prev = n;
      } else prev = 0;
    });
  }

  /* ------------------------------------------------------------ add-to-cart celebration */
  function initCart() {
    /* window capture, read-only: never preventDefault, never touches the print-choice guard
       (snippets/mx-print-flow) or the branding take-over (assets/mx-branding.js) */
    W.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.getAttribute) return;
      var act = f.getAttribute('action') || '';
      if (act.indexOf('/cart/add') === -1) return;
      ss('mx55add', JSON.stringify({ t: Date.now(), c: (W.theme && W.theme.cartCount) || 0 }));
    }, true);
    if (!(W.theme && W.theme.pageType === 'cart')) return;
    var raw = ss('mx55add');
    if (!raw) return;
    ss('mx55add', null);
    var rec; try { rec = JSON.parse(raw); } catch (e) { return; }
    if (!rec || Date.now() - rec.t > 180000 || !(W.theme.cartCount > rec.c)) return;
    var toast = D.querySelector('[data-mx55-toast] .mx55-toast__in');
    if (toast) { toast.hidden = false; timers.push(setTimeout(function () { toast.hidden = true; }, 4500)); }
    var top = D.getElementById('main'), y = top ? top.getBoundingClientRect().top : 0;
    celebrate(Math.max(0, Math.min(W.innerHeight * 0.4, y)));
  }

  function init() {
    if (H.classList.contains('mx55-off') || state() === 'off') { killAll(); return; }
    tick();
    rotateStrip();
    initFlag();
    initKeys();
    initCart();
  }

  W.MX55 = {
    setNow: function (v) { var t = typeof v === 'number' ? v : Date.parse(v); offset = t - Date.now(); paint(); return state(); },
    state: state,
    fire: function () { fire(); },
    celebrate: function () { celebrate(0); },
    running: function () { return !!cv; }
  };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
})();
